module.exports = __webpack_public_path__ + "media/assets/icons/consistency-82dda4733421786681dbf4acf9ac572e.svg";